import styled from 'styled-components';

export const Wrapper = styled.div<{
	isDocked: boolean;
	isTransparent: boolean;
}>`
	width: 100%;
	height: 85px;
	display: flex;
	position: fixed;
	top: 0;
	flex-flow: row nowrap;
	align-items: center;
	justify-content: center;
	transition: all 150ms linear;
	z-index: 9999;
	${({ isDocked, isTransparent }) =>
		!isDocked &&
		`
    	background-color: ${isTransparent ? '#0000005b' : '#0e0f43c3'};
		backdrop-filter: blur(10px);
		box-shadow: 0px 20px 20px #00000026;
    `};
`;

export const NavButtonWrapper = styled.button<{
	active: boolean;
}>`
	all: unset;
	cursor: pointer;
	user-select: none;
	text-align: center;
	padding: 8px 16px;
	border-radius: 20px;
	font-size: 12px;
	color: #f1f1f1;
	${({ active }) =>
		active &&
		`
        font-weight: 600;
        color: #fff;
    `}
	${({ active }) =>
		!active &&
		`
        &:hover {
            text-decoration: underline;
        }
    `}
`;

export const HamburgerButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	right: 20px;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
	z-index: 999;
	svg {
		width: 42px;
		height: 42px;
		fill: #fff;
	}
`;

export const SideMenuContainer = styled.div`
	position: absolute;
	right: 0;
	width: 400px;
	height: 100vh;
	top: 0;
	backdrop-filter: blur(10px);
	background-color: rgba(0, 0, 0, 0.357);
	z-index: 999;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	& > button {
		transform: scale(1.5);
		margin: 10px 0;
	}
	@media screen and (max-width: 600px) {
		width: 100%;
	}
`;

export const FullWidthNavContainer = styled.div`
	display: flex;
	align-items: center;
	svg {
		fill: #fff;
		width: auto;
		height: 35px;
		margin: 0 10px;
	}
	svg:nth-child(-2) {
		height: 30px;
	}
	svg:nth-child(-1) {
		height: 40px;
	}
`;

export const FullNavDecor = styled.div`
	width: 350px;
	height: 1px;
	background-color: #fff;
	margin: 0 10px;
`;

export const MobileSum = styled.div`
	position: absolute;
	top: 50%;
	left: 20px;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	background-color: #41454e70;
	padding: 0px 16px;
	border-radius: 5px;
	font-weight: 600;
	svg {
		fill: #fff;
		margin-right: 10px;
	}
`;
